import { Paper } from '@material-ui/core'
import { memo } from 'react'
import { FileWithPath, useDropzone } from 'react-dropzone'

import UploadIcon from '../../assets/icons/upload.svg'
import { getTranslate } from '../../localization'
import useStyles from './styles/index.styles'

interface DropBoxProps {
  onDrop: (acceptedFiles: FileWithPath[]) => void
}

const DropBox: React.FC<DropBoxProps> = ({ onDrop }) => {
  const classes = useStyles()

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <Paper className={classes.root} {...getRootProps()} elevation={4}>
      <input data-cy="dropBox" {...getInputProps()} />
      <img className={classes.icon} src={UploadIcon} alt="Upload Images" />
      {isDragActive ? (
        <p>{getTranslate('Drop the files here...')}</p>
      ) : (
        <p>
          {getTranslate(
            'Drag & drop some files here, or click to select files'
          )}
        </p>
      )}
    </Paper>
  )
}

export default memo(DropBox)
